<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="date.id ? '编辑' : '新建'"
      width="1200px"
      @close="resetForm"
  >
    <el-form
        ref="form"
        :model="date"
        :rules="ruleValidate"
        label-width="140px"
        label-suffix=" :">
      <div class="fm-section-title">基本信息</div>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="归属日历" prop="calendarId">
            <el-input v-model="calendarName" placeholder="请选择归属日历" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.calendarSelect.open()"/>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="特殊日期" prop="specialDate">
            <el-date-picker v-model="date.specialDate" type="date" value-format="yyyy-MM-dd"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="日期类型" prop="dateType">
            <el-select v-model="date.dateType" clearable>
              <el-option v-for="item in dateTypeOptions" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">时间与工时</div>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="停工开始时间">
            <el-time-picker v-model="date.stopStart" format="HH:mm:ss" value-format="HH:mm:ss"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="停工结束时间">
            <el-time-picker v-model="date.stopEnd" format="HH:mm:ss" value-format="HH:mm:ss"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="有效工时(小时)">
            <el-input-number v-model="date.effectHour" :min="0" :precision="1" controls-position="right"/>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">原因与备注</div>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="原因">
            <el-input v-model="date.reason"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注">
            <el-input v-model="date.remark" type="textarea" :rows="3"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <calendar-select
        ref="calendarSelect"
        title="选择归属日历"
        :filter="calendarFilter"
        @select="selectCalendar"
    />

    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import CalendarSelect from "../calendar/CalendarSelect";

  export default {
    components: { CalendarSelect },
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        calendarName: "",
        calendarFilter: {
          calendarCode: "",
          calendarName: "",
        },
        dateTypeOptions: [
          { label: "法定节假日", value: 1 },
          { label: "计划检修停工", value: 2 },
          { label: "临时停产", value: 3 },
          { label: "调休工作日", value: 4 },
          { label: "半天停工", value: 5 },
          { label: "节假日加班", value: 6 },
        ],
        date: {},
        ruleValidate: {
          calendarId: { required: true, message: "请选择归属日历", trigger: "change" },
          specialDate: { required: true, message: "请选择特殊日期", trigger: "change" },
          dateType: { required: true, message: "请选择日期类型", trigger: "change" },
        },
      };
    },
    methods: {
      resetForm() {
        this.$refs.form && this.$refs.form.resetFields();
      },
      open(row) {
        this.dialogVisible = true;
        this.calendarName = row ? row.calendarName || "" : "";
        this.date = Object.assign(
          {
            id: undefined,
            calendarId: 0,
            specialDate: "",
            dateType: 1,
            stopStart: "",
            stopEnd: "",
            effectHour: 0,
            reason: "",
            auditStatus: 2,
            remark: "",
          },
          row || {}
        );
      },
      selectCalendar(row) {
        this.date.calendarId = row.id;
        this.calendarName = row.calendarName;
      },
      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "fm/calendarDate", this.date)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success(this.date.id ? "编辑成功" : "添加成功");
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style scoped>
.fm-section-title {
  font-weight: bold;
  padding: 10px 0 5px;
  margin-bottom: 10px;
  border-bottom: 1px solid #e8e8e8;
  color: #409eff;
}
</style>
